<template>
    <div class="encadrer">
        <div class="grid-full grid">
            <cogi-label class="grid-full center gras" label="PiecesJustificativesJointes" />

            <template v-for="(fichier, index) in model" :key="index">
                <cogi-label cssClass="grid-begining-rest" :label="fichier.name" :dontTranslate="true" />
                <cogi-button cssClass="grid-end" cssClassButton="effacer" text="Effacer" v-on:click="deleteFile(index)" />
            </template>

            <cogi-label cssClass="grid-full redText" label="FichierJointExtensionInvalide" v-if="afficherFichierExtensionInvalide" />
            <cogi-label cssClass="grid-full redText" :label="libelleLongueurNom" :dontTranslate="true" v-if="afficherFichierNomTropLong" />
            <cogi-label cssClass="grid-full redText" :label="libelleTailleFichier" :dontTranslate="true" v-if="afficherFichierTailleInvalide" />
            <cogi-label cssClass="grid-full redText" label="FichiersJointsTailleTropGrosse" v-if="afficherFichiersTailleInvalide" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import CogiLabel from './CogiLabel.vue'
    import CogiButton from './CogiButton.vue'
    import { computed } from 'vue'
    import { useI18n } from 'vue-i18n'
    const i18n = useI18n()

    const model = defineModel<File[]>()

    interface IPropsListeFichiers {
        afficherFichierExtensionInvalide?: boolean
        afficherFichierNomTropLong?: boolean
        fichierJointMaxLongueurNom?: number
        afficherFichierTailleInvalide?: boolean
        fichierJointMaxBytes?: number
        afficherFichiersTailleInvalide?: boolean
    }

    const props = withDefaults(defineProps<IPropsListeFichiers>(), {
        afficherFichierExtensionInvalide: false,
        afficherFichierNomTropLong: false,
        fichierJointMaxLongueurNom: 0,
        afficherFichierTailleInvalide: false,
        fichierJointMaxBytes: 0,
        afficherFichiersTailleInvalide: false,
    })

    const emit = defineEmits<{
        delete: [number]
    }>()

    const fichierJointMaxMegBytes = Number(props.fichierJointMaxBytes) / 1048576

    const libelleLongueurNom = i18n.t('FichierJointNomTropLong', [props.fichierJointMaxLongueurNom])
    const libelleTailleFichier = computed(() => i18n.t('FichierJointTailleTropGrosse', [fichierJointMaxMegBytes]))

    function deleteFile(index: number) {
        emit('delete', index)
    }
</script>
